export const QUERY_KEYS = /** @type {const} */ ({
  METADATA: 'METADATA',
  METRICS_GRAPH: 'METRICS_GRAPH',
  USAGE_DATA: 'USAGE_DATA',
  DASHBOARD: 'DASHBOARD'
});
